<template>
  <div id="app" class="app">
    <div class="container">
      <transition name="fade">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
@import "main.scss";
	.app {
		position: absolute;
		top: 0;
		height: 100%;
		width: 100%;
		background-color: $color-black;
		@include font("regular");
	}
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}
</style>
